'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { track as dashboardTracker, EVENTS } from 'dashboard-ui-components/tracking/DashboardUITracker';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import AddReport from '../dashboard/header/AddReport';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class GenericEmptyState extends PureComponent {
  constructor(...args) {
    super(...args);
    this.handleDocClick = () => {
      dashboardTracker(EVENTS.clickHelpOnEmptyState);
    };
  }
  componentDidMount() {
    dashboardTracker(EVENTS.viewEmptyState);
  }
  render() {
    const {
      dashboardId
    } = this.props;
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      paddingBlock: "1000",
      children: [/*#__PURE__*/_jsx(Illustration, {
        name: "add-on-reporting",
        width: "20%",
        paddingBlockEnd: "800"
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "genericEmptyState.subtext"
        })
      }), /*#__PURE__*/_jsx(AddReport, {
        currentDashboardId: dashboardId,
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "genericEmptyState.button"
        }),
        sourceName: "empty-state"
      }), /*#__PURE__*/_jsxs(Text, {
        paddingBlockStart: "400",
        as: "p",
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "genericEmptyState.learnMore"
        }), ' ', /*#__PURE__*/_jsx(Link, {
          href: "https://knowledge.hubspot.com/dashboard/customize-your-dashboards",
          external: true,
          onClick: this.handleDocClick,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "genericEmptyState.docLinkText"
          })
        })]
      })]
    }, "no-widgets-empty-state");
  }
}
GenericEmptyState.propTypes = {
  dashboardId: PropTypes.number.isRequired
};
export default GenericEmptyState;